<template>
  <b-modal
    id="charge-order"
    ref="chargeOrderRef"
    title="手动收取费用"
  >
    <div class="alert alert-success">
      <span>1.所有手动收取费用在导出的对账表格里面显示为“手动收费”</span>
      <br>
      <span>2.可以通过创建一笔金额为负的费用，纠正之前错误的收费操作</span>  
    </div>
    
    <form id="charge-order-form">
      <div class="form-group row">
        <label class="col-sm-3 col-form-label">金额</label>
        <div class="input-group col input-group-sm">
          <input type="text" class="form-control" v-model.number="amount" name="amount" placeholder="金额可以为负"
            v-validate="{ required: true, decimal: 3 }"
            :class="{'required': true, 'is-invalid': errors.has('amount')}">
          <div class="input-group-append">
            <div class="input-group-text">元</div>
          </div>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-sm-3 col-form-label">备注</label>
        <div class="input-group col input-group-sm">
          <input type="text" class="form-control" v-model="calculation" name="calculation" placeholder=""
            v-validate="{ required: true }"
            :class="{'is-invalid': errors.has('calculation')}">
        </div>
      </div>
      
    </form>

    <div slot="modal-footer" class="w-100">
      <button class="btn btn-secondary float-right" @click="$refs.chargeOrderRef.hide();">关闭</button>
      <button class="btn btn-primary float-right" @click="chargeOrder">提交</button>
   </div>
  </b-modal>
</template>

<script>
import OrderMixin from '@/mixins/order'

function showChargeOrderModel () {
  this.$refs.chargeOrderRef.show()
}

function chargeOrder () {
  this.$validator.validateAll().then((result) => {
    if (!result) {
      return
    }

    let data = {
      amount: this.amount,
      calculation: this.calculation
    }

    if (this.amount === 0) {
      alert('0块钱收个毛线')
      return
    }

    this.$http.post(`/api/orders/${this.orderNo}/charge`, data).then((result) => {
      this.$refs.chargeOrderRef.hide()
    })
  })
}

export default {
  name: 'calculate-order-price',
  props: ['orderNo'],
  mixins: [OrderMixin],
  data () {
    return {
      amount: 0,
      calculation: ''
    }
  },
  components: {
  },
  methods: {
    showChargeOrderModel,
    chargeOrder
  }
}
</script>